// extracted by mini-css-extract-plugin
export default {"viewButton":"insurance-table_viewButton__5iAuz","spin":"insurance-table_spin__CuxfM"};